export const FUNNELLAB_AGENCY_ID = 'ee5adfe4-51e2-44b9-95e8-364792d80e7b';
export const MAXIMUM_DROPDOWN_ITEMS = 7;
export const CENTER_OF_GERMANY = { lat: 51.163361, lng: 10.447683 };

export const DEFAULT_VERIFY_MAIL_RESEND_WAITING_TIME = 60; // seconds

export const IMGLY_TEMPLATES_FOLDER = 'ad7d45e0-98cc-4a79-944e-b0bf669bfc71';
export const IMGLY_TEMPLATES_PREVIEW_FOLDER =
  'e7b7b601-4d1c-427c-a388-c1ab09fef5f8';
export const CREATIVE_BUILDER_ASSETS_FOLDER =
  '92f86ee8-acac-4acb-8724-dc71bce3587b';
export const CREATIVE_BUILDER_FOLDER = 'ecb539da-c390-48f0-9d8c-326709b0b609';

export const JOB_CREATIVES_FOLDER = '3ff20853-43a4-43a4-ae01-cae9175486d2';
export const JOB_CREATIVE_SCENES_FOLDER =
  '162df3b6-7a90-4479-8794-95e0cb817f13';
